

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timezoneDate',
  standalone: true
})
export class TimezoneDatePipe implements PipeTransform {
  //To show date time on all timezones by monisha
  transform(utcDate: string | Date, format: string = 'default'): string {
    if (!utcDate) return '';
    let timeZone = localStorage.getItem('timezonedate');
    if (!timeZone || timeZone === 'null' || timeZone === 'undefined') {
      timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    if (!timeZone || typeof timeZone !== 'string' || timeZone.trim() === '') {
      return '';
    }

    const parsedDate = new Date(utcDate);
    if (isNaN(parsedDate.getTime())) {
      return '';
    }

    try {
      const options: Intl.DateTimeFormatOptions = { timeZone };

      if (format === 'MM/dd/yyyy') {
        options.year = 'numeric';
        options.month = '2-digit';
        options.day = '2-digit';
      } else if (format === 'h:mm a') {
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.hour12 = true;
      } else if (format === 'hh:mm:ss a') {
        // Time-with-seconds, used by the Referrals "Last Updated" column which
        // renders date and time on separate lines. Matches the old
        // `| date:'hh:mm:ss a'` output but honours the user's timezone.
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.second = '2-digit';
        options.hour12 = true;
      }
       else if (format === 'MMMM dd, yyyy') {
        options.year = 'numeric';
        options.month = 'long';
        options.day = '2-digit';
      }
      
      
      else if (format === 'MMM dd, yyyy hh:mm a') {
        // e.g. "Jan 30, 2026, 03:45 PM" - date and time without seconds (Post section).
        options.year = 'numeric';
        options.month = 'short';
        options.day = '2-digit';
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.hour12 = true;
      } else if (format === 'customFormat') {
        const month = parsedDate.toLocaleString('en-US', { month: 'long', timeZone });
        const day = parsedDate.toLocaleString('en-US', { day: '2-digit', timeZone });
        const year = parsedDate.toLocaleString('en-US', { year: '2-digit', timeZone });
        const time = parsedDate.toLocaleString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          // second: '2-digit',
          hour12: true,
          timeZone
        });
        return `${month} ${day} ${year}  ${time}`;
      } else if (format === 'dd MMM yyyy') {
        // Day-month-year (e.g. "18 Mar 2026"), assembled in the configured
        // zone. Matches the old Angular `| date:'dd MMM yyyy'` output that this
        // replaces, but honours the user's timezone instead of browser-local.
        const day = parsedDate.toLocaleString('en-US', { day: '2-digit', timeZone });
        const month = parsedDate.toLocaleString('en-US', { month: 'short', timeZone });
        const year = parsedDate.toLocaleString('en-US', { year: 'numeric', timeZone });
        return `${day} ${month} ${year}`;
      } else if (format === 'dd MMM') {
        // Day + short month, no year (e.g. "10 Jul"), assembled in the
        // configured zone. Matches the old `| date:'dd MMM'` output (V3 timeline
        // step dates) but honours the user's timezone instead of browser-local.
        const day = parsedDate.toLocaleString('en-US', { day: '2-digit', timeZone });
        const month = parsedDate.toLocaleString('en-US', { month: 'short', timeZone });
        return `${day} ${month}`;
      }  else if (format === 'custom') {
                options.weekday = 'short';
                options.year = 'numeric';
                options.month = '2-digit';
                options.day = '2-digit';
                options.hour = '2-digit';
                options.minute = '2-digit';
                // options.second = '2-digit';
                options.hour12 = true;
              }
      else {
        options.year = 'numeric';
        options.month = '2-digit';
        options.day = '2-digit';
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.second = '2-digit';
        options.hour12 = true;
      }
      return new Intl.DateTimeFormat('en-US', options).format(parsedDate);
    } catch (error) {
      return '';
    }
  }
}

